import { type CustomerModelCloudConnectModel } from "@doitintl/cmp-models";
import { type ModelIdRef } from "@doitintl/models-any";

import { AWSFeatureName } from "../../Settings/AWS/types";

export const isRealTimeAnomaliesEnabled = (cloudConnectDocs: ModelIdRef<CustomerModelCloudConnectModel>[]): boolean =>
  cloudConnectDocs.some(
    (doc) =>
      doc.cloudPlatform === "amazon-web-services" &&
      Array.isArray(doc.supportedFeatures) &&
      doc.supportedFeatures.some(
        (feature) => feature.name === AWSFeatureName.realTimeData && feature.hasRequiredPermissions === true
      )
  );

export const hasHealthyRealTimePermissions = (
  cloudConnectDocs: ModelIdRef<CustomerModelCloudConnectModel>[]
): boolean =>
  cloudConnectDocs.some(
    (doc) => doc.cloudPlatform === "amazon-web-services" && doc.healthyFeatures?.[AWSFeatureName.realTimeData] === true
  );
